// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IModelResponse, IModel } from '@cian/http-api';
import type { IGetMyOffersForSelectionResponseSchema } from '../../entities/get_my_offers_for_selection/GetMyOffersForSelectionResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetMyOffersForSelectionDesktopRequest {
  /** Начиная с какой позиции по порядку вернуть объявления **/
  offset: number;
  /** Вернётся не больше указанного числа объявлений **/
  limit: number;
  /** Для какого таба объявления **/
  tabType: ETabType;
}
export enum ETabType {
  /** Сдаю **/
  'Rent' = 'rent',
  /** Продаю **/
  'Sale' = 'sale',
}

export type IGetMyOffersForSelectionDesktopResponse = IGetMyOffersForSelectionResponseSchema;

export interface IGetMyOffersForSelectionDesktopResponse200
  extends IModelResponse<IGetMyOffersForSelectionDesktopResponse> {
  statusCode: 200;
}

export type IGetMyOffersForSelectionDesktopResponseError = IErrorResponseSchema;

export interface IGetMyOffersForSelectionDesktopResponse400
  extends IModelResponse<IGetMyOffersForSelectionDesktopResponseError> {
  statusCode: 400;
}

export type TGetMyOffersForSelectionDesktopResponse =
  | IGetMyOffersForSelectionDesktopResponse200
  | IGetMyOffersForSelectionDesktopResponse400;

export type TGetMyOffersForSelectionDesktopModel = IModel<
  IGetMyOffersForSelectionDesktopRequest,
  TGetMyOffersForSelectionDesktopResponse
>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetMyOffersForSelectionDesktopResponse): TResponse200;
  400(response: IGetMyOffersForSelectionDesktopResponseError): TResponse400;
}
